import * as React from "react";
import * as ReactDOM from "react-dom";

export class CardHeader extends React.Component<{}, {}> {
  render() {
    return <div className="block block_title">{this.props.children}</div>;
  }
}
